function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { injectTestId } from "@cvent/nucleus-test-automation";
import React from "react";
import { useCarousel } from "./CarouselContext";
import { useDotPosition } from "../hooks/useDotPosition";
import { useDotVariant } from "../hooks/useDotVariant";
import useStyle from "./Dot.style";
import { VisuallyHiddenElement } from "../../VisuallyHiddenElement";
import { getPanelId, getTabId } from "../hooks/useUniquePrefix";
export var Dot = function(param) {
    var distanceFromActive = param.distanceFromActive, numberOfDots = param.numberOfDots, index = param.index, dotsAriaLabel = param.dotsAriaLabel, dotSize = param.dotSize, isHidden = param.isHidden, hiddenLastSlide = param.hiddenLastSlide;
    var ref = useCarousel(), _state = ref.state, isRtl = _state.isRtl, slideIndex = _state.slideIndex, testID = _state.testID, slideLabels = _state.slideLabels, prefixId = _state.prefixId;
    var slideLabel = slideLabels[index];
    var variant = useDotVariant({
        distanceFromActive: distanceFromActive,
        numberOfDots: numberOfDots,
        index: index,
        slideIndex: slideIndex
    });
    var position = useDotPosition({
        distanceFromActive: distanceFromActive,
        numberOfDots: numberOfDots,
        index: index,
        slideIndex: slideIndex
    });
    var ref1 = useCarousel(), setSlideIndex = ref1.actions.setSlideIndex;
    var dot = useStyle({
        dotSize: dotSize,
        isRtl: isRtl,
        position: position,
        variant: variant
    }).dot;
    return isHidden ? _jsx(VisuallyHiddenElement, _objectSpread({}, injectTestId(testID && "".concat(testID, ".hiddenDot.").concat(index)), {
        children: _jsx("button", _objectSpread({}, injectTestId(testID && "".concat(testID, ".dot.").concat(index)), {
            "aria-label": dotsAriaLabel ? dotsAriaLabel(index) : undefined,
            role: "tab",
            "aria-selected": index === slideIndex,
            onClick: function() {
                return setSlideIndex(hiddenLastSlide !== null && hiddenLastSlide !== void 0 ? hiddenLastSlide : index);
            },
            id: getTabId(prefixId, "".concat(index)),
            "aria-controls": getPanelId(prefixId, "".concat(index)),
            tabIndex: -1,
            type: "button",
            children: slideLabel && _jsx(VisuallyHiddenElement, {
                children: slideLabel
            })
        }))
    })) : _jsx("button", _objectSpread({
        css: dot
    }, injectTestId(testID && "".concat(testID, ".dot.").concat(index)), {
        "aria-label": dotsAriaLabel ? dotsAriaLabel(index) : undefined,
        role: "tab",
        "aria-selected": index === slideIndex,
        onClick: function() {
            return setSlideIndex(index);
        },
        id: getTabId(prefixId, "".concat(index)),
        "aria-controls": getPanelId(prefixId, "".concat(index)),
        tabIndex: -1,
        type: "button",
        children: slideLabel && _jsx(VisuallyHiddenElement, {
            children: slideLabel
        })
    }));
};
Dot.defaultProps = {
    dotSize: 'l'
};
export default Dot;
